import React from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12
      }
    }
  };

  const buttonVariants = {
    hover: {
      scale: 1.05,
      boxShadow: '0 10px 30px rgba(16, 185, 129, 0.3)',
      transition: {
        type: 'spring',
        stiffness: 400,
        damping: 10
      }
    },
    tap: {
      scale: 0.95
    }
  };

  return (
    <section className="hero">
      <motion.div
        className="hero-container"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1 variants={itemVariants} className="hero-title">
          Digital receipts, without the paper.
        </motion.h1>
        <motion.p variants={itemVariants} className="hero-subtitle">
          Snaply delivers receipts instantly at checkout, saving money and reducing waste.
        </motion.p>
        <motion.div variants={itemVariants} className="hero-buttons">
          <motion.a
            href="https://docs.google.com/forms/d/e/1FAIpQLSeJCPt3TWcWuFfj6pH0qTzV4qOf-vKA9UIh1Vl6f4hxXAxKzA/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
          >
            Join the waitlist
          </motion.a>
          <motion.button
            className="btn btn-secondary"
            variants={buttonVariants}
            whileHover="hover"
            whileTap="tap"
          >
            For retailers
          </motion.button>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
